import { differenceInYears } from 'date-fns';

/**
 * Дата рождения в профиле необязательна, и почти каждый вызывающий получает её как
 * `string | null`. Отсюда и сторож в первой строке — тип просто не говорил того, что функция
 * и так умеет, поэтому тесты на пустой вход приходилось протаскивать через `as any`.
 */
export const getAge = (startingDate: string | Date | null | undefined): number | null => {
  if (!startingDate) {
    return null;
  }
  const date = new Date(startingDate);

  return Math.abs(differenceInYears(date, new Date()));
};
